import React, { useEffect, useState } from "react";
import { useProductData } from "@/zustand/productStore";
import { useCartData } from "@/zustand/cartStore";
import ProductCardNew from "@/components/productCards/productCardNew";
import ProductCardVariant from "@/components/productCards/productCardVariant";

const ProductsList = ({ modifications }) => {
  const [groupedVariants, setGroupedVariants] = useState(null);
  const productData = useProductData();
  const { selectedProduct, variants } = useCartData();
  const variantsEnabled = productData?.enable_size_variants || productData?.enable_color_variants;

  useEffect(() => {
    const groupedData = variants?.slice(0, selectedProduct?.amount).reduce((acc, curr) => {
      const key = `${curr?.size && curr?.size}-${curr?.color && curr?.color}`;
      if (!acc[key]) {
        acc[key] = {
          size: curr?.size,
          sizeLabel: curr?.sizeLabel,
          color: curr?.color,
          colorLabel: curr?.colorLabel,
          amount: 0,
        };
      }
      acc[key].amount++;
      return acc;
    }, {});

    setGroupedVariants(groupedData);
  }, [variants, selectedProduct]);

  return (
    <div className="product-list-drawer">
      {variantsEnabled &&
        groupedVariants &&
        Object.values(groupedVariants).map((item, index) => {
          return <ProductCardVariant key={index} product={selectedProduct} variant={item} amount={item.amount} />;
        })}
      {selectedProduct && !variantsEnabled && <ProductCardNew product={selectedProduct} index={1} />}
      {selectedProduct?.fake_products &&
        selectedProduct?.enable_fake_products &&
        selectedProduct.fake_products.map((product, index) => (
          <ProductCardNew product={product} key={index} modifications={modifications} type="fake" />
        ))}
    </div>
  );
};

export default ProductsList;
